import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Table from '../../../../components/Table/Table';
import Typography from '../../../../components/Typography/Typography';
import { useLoader } from '../../../../hooks';
import classes from '../../../../styles/AllDevices.module.css';
import AdminClasses from '../Admin.module.css';
import CustomTooltip from '../../../../components/CustomToolTip/CustomTooltip';
import { SET_USER } from '../../../../constants';
import { AuthContext } from '../../../../context/AuthContext';

import DeleteModal from '../../../../components/DeleteModal/DeleteModal';
import ModalComponent from '../../../../components/ModalComponent/ModalComponent';
import { UilPen } from '@iconscout/react-unicons';
import { UilSignout } from '@iconscout/react-unicons';
import { UilTrash } from '@iconscout/react-unicons';
import { EnablerService } from '../../../../services/EnablerService';

const Enablers = ({ setCreateEditEnabler, setSelectedIndex, tabslength, updateQueryParams }) => {
    const [startLoader, stopLoader] = useLoader();
    const [showModal, setShowModal] = useState(false);
    const [customers, setCustomers] = useState();
    const [selectedAdmin, setSelectedAdmin] = useState();
    const [deleteModal, setDeleteModal] = useState({
        status: false,
        enablerId: '',
    });
    const [admins, setAdmins] = useState([]);
    const { dispatch: authDispatch } = useContext(AuthContext);
    const dispatchSetUser = (payload) => authDispatch({ type: SET_USER, payload });

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        EnablerService.ReadAll(startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleGetCustomersSuccess = ({ data }, id) => {
        if (data?.data[0]) {
            setCustomers(data?.data);
            setShowModal(true);
        } else {
            setDeleteModal({ status: true, enablerId: id });
        }
    };

    const handleDelete = () => {
        const data = {
            id: deleteModal.enablerId,
        };
        EnablerService.Delete(data, startLoader, handleDeleteSuccess, handleError, stopLoader);
    };

    const handleDeleteSuccess = (res) => {
        if (res) {
            toast.success('Enabler deleted');
            setDeleteModal({ status: false, enablerId: '' });
            getData();
        }
    };

    const handleSuccess = ({ data }) => {
        if (data.data?.length) {
            setAdmins(
                data.data.map((item, index) => ({
                    ...item,
                    's.no': index + 1,
                    contact: item.contact ? `${item.countryCode ? item.countryCode : ''} ${item.contact}` : '--',
                    profile: (
                        <div className={AdminClasses.ProfileIconContainer}>
                            <img className={AdminClasses.ProfileIcon} src={item.profileImage} alt={`${item.name} profile image`} />
                        </div>
                    ),
                    hasAccess: (
                        <div className={AdminClasses.ProfileIconContainer}>
                            {item.accessBlocked ? <div className={AdminClasses.AccessBlocked}></div> : <div className={AdminClasses.AccessNotBlocked}></div>}
                        </div>
                    ),
                    action: (
                        <div className={AdminClasses.ActionContainer}>
                            <CustomTooltip content={'Edit Enabler'}>
                                <div
                                    onClick={() => {
                                        setCreateEditEnabler({ status: true, data: item });
                                        setSelectedIndex(tabslength);
                                    }}
                                >
                                    <UilPen size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                                </div>
                            </CustomTooltip>
                            <CustomTooltip content={'Login As Enabler'}>
                                <div onClick={() => handleLoginAs(item._id)}>
                                    <UilSignout size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                                </div>
                            </CustomTooltip>
                            <CustomTooltip content={'Delete Enabler'}>
                                <div onClick={() => setDeleteModal({ status: true, enablerId: item._id })}>
                                    <UilTrash size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                                </div>
                            </CustomTooltip>
                        </div>
                    ),
                }))
            );
        } else {
            setAdmins([]);
        }
    };

    const handleLoginAs = (id) => {
        EnablerService.LoginAs(id, startLoader, handleLoginAsSuccess, handleError, stopLoader);
    };

    const handleLoginAsSuccess = ({ data }) => {
        if (data.data) {
            updateQueryParams('tab', 0);
            dispatchSetUser({ user: {}, token: data.data });
            window.location.reload();
        }
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    return (
        <div className={classes.AllDevices}>
            <DeleteModal
                deletefunction={handleDelete}
                opendeleteModal={deleteModal.status}
                setOpenDeleteModal={(status) => setDeleteModal({ ...deleteModal, status })}
            ></DeleteModal>
            <div className={classes.Header}>
                <div>
                    <Typography content="All Enablers" />
                    <div className={classes.TableCount}>
                        Total Count :
                        <span>
                            <Typography size="14" content={admins.length} />
                        </span>
                    </div>
                </div>
                <div>
                    <button
                        type="submit"
                        className="btn-primary"
                        style={{ marginTop: '0' }}
                        onClick={() => {
                            setCreateEditEnabler({ status: true, data: {} });
                            setSelectedIndex(tabslength);
                        }}
                    >
                        Create Enabler
                    </button>
                </div>
            </div>
            <div>
                <Table
                    head={['S.No', '', 'Name', 'Contact', 'Email', 'Access', 'Action']}
                    keys={['s.no', 'profile', 'name', 'contact', 'email', 'hasAccess', 'action']}
                    data={admins}
                />
            </div>
        </div>
    );
};

export default Enablers;
